import { InjectionToken } from '@angular/core';
import { CountryIso2Code } from '../models/country/country-iso-2-code.enum';

export const COUNTRY_ISO_2_CODE = new InjectionToken<CountryIso2Code>('Country ISO 2 code');
